import { QBankStructureValidationCase } from '@exam-management/graphql';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { type PropsWithChildren, zodResolver } from '@shared/utils';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import {
  QBankStructureLevelFormSchema,
  type QBankStructureLevelFormInput,
} from './qbank-structure-level-form-schema';

interface QBankStructureLevelFormProviderProps extends PropsWithChildren {
  initialValues?: QBankStructureLevelFormInput;
}

export default function QBankStructureLevelFormProvider(
  props: Readonly<QBankStructureLevelFormProviderProps>,
) {
  const { initialValues, children } = props;

  const { validatePublishQBankStructure } = useQBankStructure();

  const formContext = useForm<QBankStructureLevelFormInput>({
    mode: 'onChange',
    defaultValues: initialValues ?? {},
    resolver: zodResolver(QBankStructureLevelFormSchema),
  });

  useEffect(() => {
    if (initialValues) {
      formContext.reset(initialValues);
    }
  }, [initialValues]);

  useEffect(() => {
    if (validatePublishQBankStructure.errors) {
      for (const error of validatePublishQBankStructure.errors) {
        if (error.type === QBankStructureValidationCase.MissingNameInInformationItem) {
          formContext.setError(error.name, {
            type: error.type,
            message: 'กรุณาระบุชื่อ',
          });
        }
      }
    }
  }, [validatePublishQBankStructure.errors, formContext]);

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
